import { render, staticRenderFns } from "./TrainingEventBooking.vue?vue&type=template&id=6d252b88&"
import script from "./TrainingEventBooking.vue?vue&type=script&lang=js&"
export * from "./TrainingEventBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports